export const homeBanner = {
  background: "gray",
  padding: "0 7% 0 4%",
};


export const heading = {
  fontFamily: "Inter",
  fontWeight: 600,
  fontSize: "30px",
  lineHeight: "36px",
  color: "#000000",
  mb:3
};
export const subHeading = {
  color: "#3665D0",
  fontFamily: "Inter",
  fontWeight: 500,
  fontSize: "18px",
  lineHeight: "22px",
};

export const mainHeading = {
  display: "block",
  marginTop: "2%",
  fontSize:{md: "42px", xs: "30px"},
  fontWeight: 600,
  lineHeight: "120%",
  color: "#000",
  textTransform: "capitalize",
};

export const showCaseBtn = {
  px: 5,
  py: 2,
  mt:3,
  bgcolor: "#3665D0",
  textTransform: "none",
  fontFamily: "Inter",
  color: '#fff',
  fontWeight: 500,
  boxShadow: '0px 2px 4.5px rgba(0, 0, 0, 0.160784)',
  fontSize: '14px',
  border: '1px solid #3665D0',
  borderRadius: '8px'
};
export const clientBtn = {
  px: 3,
  py: 1,
  bgcolor: "#3665D0",
  textTransform: "none",
  fontFamily: "Inter",
  color: '#fff',
  fontWeight: 500,
  boxShadow: '0px 2px 4.5px rgba(0, 0, 0, 0.160784)',
  fontSize: '14px',
  border: '1px solid #3665D0',
  borderRadius: '8px'
};

export const servicefeature ={
  fontFamily:'Inter', bgcolor:'#F8FAFF', borderRadius:'40px',   boxShadow: '0px 22.9827823638916px 45.9655647277832px -8.61854362487793px #3665D014', border: '1px solid #D2D2D299'
}


export const clientsCard = {
  width: '100%',
  color: '#000',
  fontSize: '12px',
  fontWeight: 500,
  background: '#FFFFFF',
  border: '1px solid rgba(210, 210, 210, 0.3)',
  boxShadow: '0px 32px 15px -12px rgba(54, 101, 208, 0.08)',  
  borderRadius: '20px',
  my:' 16%',
};
